import React from 'react';

const BusinessManagement = React.lazy(() => import('./BusinessManagement'));
const ViewBusiness = React.lazy(() => import('./ViewBusiness'));

export const businessManagementRouteConfigs = [
  {
    path: '/business-management',
    element: <BusinessManagement />,
  },
  {
    path: '/business-management/:id',
    element: <ViewBusiness />,
  },
];
